// extracted by mini-css-extract-plugin
export default {"root":"CollapseHeader_root__Z-d49","clickable":"CollapseHeader_clickable__BKwmd","content":"CollapseHeader_content__Iy6Cl"};